import { defineMessages } from 'react-intl';

export default defineMessages({
  date: { id: 'table.headers.date' },
  picture: { id: 'table.headers.picture' },
  name: { id: 'table.headers.name' },
  recallCountryName: { id: 'table.headers.recall' },
  manufacturerName: { id: 'table.headers.made' },
  language: { id: 'table.headers.lang' },
  authoritiesLink: { id: 'table.headers.provider.link' },
  documentTitle: { id: 'document.title' },
  searchTermPlaceholder: { id: 'search.tip' },
  recallCategorisation: { id: 'details.recalls.categorisation.title' },
  segment: { id: 'details.segment' },
  family: { id: 'details.family' },
  class: { id: 'details.class' },
  brick: { id: 'details.brick' },
  recallDetails: { id: 'details.recalls.details.title' },
  alert: { id: 'details.original.alert' },
  manufacturerDetails: { id: 'details.manufacturer.details.title' },
  manufacturerCountry: { id: 'details.country' },
  detailsManufacturerName: { id: 'details.manufacturer.name' },
  manufacturerWebsite: { id: 'details.manufacturer.website' },
  productDetails: { id: "details.product.details.title" },
  type: { id: "details.product.type" },
  productName: { id: "details.product.name" },
  description: { id: "details.product.description" },
  modelAndVolume: { id: "details.product.model.volume" },
  riskLevel: { id: "details.product.risk.level" },
  hazard: { id: "details.product.hazard" },
  injury: { id: "details.product.injury" },
  action: { id: "details.product.action" },
  units: { id: "details.product.units" },
  gtinParagraph: { id: "details.product.gtinParagraph" },
  gtinNumber: { id: "details.product.gtinNumber" },
  gtinDesc: { id: "details.product.gtinDesc" },
  gtinProductType: { id: "details.product.gtinProductType" },
  htsParagraph: { id: "details.product.htsParagraph" },
  htsCode: { id: "details.product.htsCode" },
  htsDesc: { id: "details.product.htsDesc" },
  htsProductType: { id: "details.product.htsProductType" },
  distributorParagraph: { id: "details.product.distributorParagraph" },
  distributorName: { id: "details.product.distributorName" },
  distributorWebsite: { id: "details.product.distributorWebsite" }, 
  spotlightPlaceholder: { id: 'filter.placeholder' },
  apiKeyPlaceholder: { id: 'admin.apiKey.placeholder' },
  adminImportDocumentation: { id: 'admin.importDocumentation' },
});



// WEBPACK FOOTER //
// ./src/utils/messages.js